import React from "react";
import Stepper from "./Stepper/Stepper";
import { Step1 } from "./Step1";
import { Step2 } from "./Step2";
import { Step3 } from "./Step3";
import { Step4 } from "./Step4";
import { StartMessage } from "./StartMessage";
import { AudioVideo } from "./AudioVideo";
import { Checklist } from "./Checklist";
import { PersonalInstructions } from "./PersonalInstructions";
import { ContactList } from "./ContactList";
import { EmailandText } from "./EmailandText";
import { Funeralwishes } from "./Funeralwishes";
import { PasswordList } from "./PasswordList";
import { BillsToPay } from "./BillsToPay";
import { AssetsandLiabilites } from "./AssetsandLiabilites";
import { DocumnetList } from "./DocumnetList";
import { LitigationList } from "./LitigationList";
import { LocationofItems } from "./LocationofItems";
export default function demoStepper() {
  const mysteps = [
    {
      step: "1",
      name: "Start Here",
    },
    {
      step: "2",
      name: "Audio Video",
    },
    {
      step: "3",
      name: "Checklist",
    },
    {
      step: "4",
      name: "Personal Instructions",
    },
    {
      step: "5",
      name: "Contact List",
    },
    {
      step: "6",
      name: "Emails and Texts",
    },
    {
      step: "7",
      name: "Funeral Wishes",
    },
    {
      step: "8",
      name: "List of Passwords",
    },
    {
      step: "9",
      name: "Bills to Pay",
    },
    {
      step: "10",
      name: "Assets and Liabilities",
    },
    {
      step: "11",
      name: "Important Documents",
    },
    {
      step: "12",
      name: "Litigation List",
    },
    {
      step: "13",
      name: "Location of Personal Items",
    },
  ];
  const trusteeSteps = [
    {
      step: "1",
      name: "Start Here",
    },
    {
      step: "2",
      name: "Checklist",
    },
    {
      step: "3",
      name: "Audio Video",
    },
    {
      step: "4",
      name: "Personal Instructions",
    },
    {
      step: "5",
      name: "Emails and Texts",
    },
    {
      step: "6",
      name: "Contact List",
    },
    {
      step: "7",
      name: "Funeral Wishes",
    },
    {
      step: "8",
      name: "List of Passwords",
    },
    {
      step: "9",
      name: "Bills to Pay",
    },
    {
      step: "10",
      name: "Assets and Liabilities",
    },
    {
      step: "11",
      name: "Important Documents",
    },
    {
      step: "12",
      name: "Litigation List",
    },
    {
      step: "13",
      name: "Location of Personal Items",
    },
  ];

  const contentComponents = [
    StartMessage,
    AudioVideo,
    Checklist,
    PersonalInstructions,
    ContactList,
    EmailandText,
    Funeralwishes,
    PasswordList,
    BillsToPay,
    AssetsandLiabilites,
    DocumnetList,
    LitigationList,
    LocationofItems,
  ];
  const contentComponentsTrustee = [
    StartMessage,
    Checklist,
    AudioVideo,
    PersonalInstructions,
    EmailandText,
    ContactList,
    Funeralwishes,
    PasswordList,
    BillsToPay,
    AssetsandLiabilites,
    DocumnetList,
    LitigationList,
    LocationofItems,
  ];
 const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role") || null);
  // const userRole =
  //   localStorage.getItem("role") != "undefined" ||
  //   (localStorage.getItem("role") != "null" &&
  //     JSON.parse(localStorage.getItem("role")));
  //     console.log("steps in truestt",userRole1)
  return (
    <>
      <Stepper
        steps={userRole && userRole === "protrustee" ? trusteeSteps : mysteps}
        contentComponents={
          userRole && userRole === "protrustee"
            ? contentComponentsTrustee
            : contentComponents
        }
      />
    </>
  );
}
